<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">{{
                $t("sectionEmail.emailNovoEmail")
              }}</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>{{ $t("textObrigatorios") }}</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>* {{ $t("sectionEmail.emailEmail") }}</label>
                    <input
                      v-model="viewModel.email"
                      class="form-control"
                      type="email"
                      placeholder="Digite o e-mail"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>* {{ $t("textUsuario") }}</label>
                    <input
                      v-model="viewModel.usuario"
                      class="form-control"
                      type="text"
                      placeholder="Digite o usuário"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-6 col-md-2 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>* {{ $t("sectionUsuario.usuarioSenha") }}</label>
                    <input
                      v-model="viewModel.senha"
                      class="form-control"
                      type="password"
                      placeholder="Digite a senha"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionEmail.emailDataLimite") }}</label
                    >
                    <input
                      class="form-control"
                      type="date"
                      placeholder="Digite a data limite"
                      required
                      :value="
                        viewModel.dataLimite &&
                        viewModel.dataLimite.toISOString().split('T')[0]
                      "
                      @input="viewModel.dataLimite = $event.target.valueAsDate"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionEmail.emailTipoServidor") }}</label
                    >
                    <select
                      v-model="viewModel.tipoServidor"
                      class="form-control"
                      required
                    >
                      <option disabled selected value>
                        {{ $t("textSelecione") }}
                      </option>
                      <option disabled selected value>
                        {{ $t("textSelecione") }}
                      </option>
                      <option value="1">IMAP</option>
                      <option value="2">POP3</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionEmail.emailServidorEntrada") }}</label
                    >
                    <input
                      v-model="viewModel.hostEntrada"
                      class="form-control"
                      type="text"
                      placeholder="Digite o host de entrada"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionEmail.emailPortaEntrada") }}</label
                    >
                    <input
                      v-model="viewModel.portaEntrada"
                      class="form-control"
                      type="number"
                      placeholder="Digite a porta de entrada"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>{{ $t("sectionEmail.emailSSLentrada") }}</label>
                    <b-form-checkbox
                      v-model="viewModel.sslEntrada"
                      name="check-button"
                      switch
                    >
                      {{ $t("textYes") }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionEmail.emailServidorSaida") }}</label
                    >
                    <input
                      v-model="viewModel.hostSaida"
                      class="form-control"
                      type="text"
                      placeholder="Digite o host saída"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for
                      >* {{ $t("sectionEmail.emailPortaSaida") }}</label
                    >
                    <input
                      v-model="viewModel.portaSaida"
                      class="form-control"
                      type="number"
                      placeholder="Digite a porta sáida"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label for>{{ $t("sectionEmail.emailSSsaida") }}</label>
                    <b-form-checkbox
                      v-model="viewModel.sslSaida"
                      name="check-button"
                      switch
                    >
                      {{ $t("textYes") }}
                    </b-form-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-success mr-2" type="submit">
            {{ $t("btSalvar") }}
          </button>
          <button
            class="btn btn-secondary"
            type="reset"
            @click="$router.push('/configuracao-email')"
          >
            {{ $t("btVoltar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "NovaConfiguracaoEmail",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      viewModel: {
        id: this.$store.state.emptyGuid,
        contaId: this.$store.getters.getAutenticacao.contaSelecionadaId,
        email: "",
        usuario: "",
        senha: "",
        hostEntrada: "",
        portaEntrada: "",
        sslEntrada: false,
        hostSaida: "",
        portaSaida: "",
        sslSaida: false,
        dataLimite: "",
        tipoServidor: ""
      }
    };
  },
  mounted() {},
  created() {
    let configuracaoEmailId = this.$route.params.id;
    if (configuracaoEmailId) this.Obter(configuracaoEmailId);
  },
  methods: {
    ValidarForm(evt) {
      evt.preventDefault();
      if (this.viewModel.id !== this.$store.state.emptyGuid) this.Editar();
      else this.Novo();
    },
    Obter(configuracaoEmailId) {
      this.loading = true;
      this.$http({
        url: "configuracao-email/obter/" + configuracaoEmailId,
        method: "GET"
      })
        .then((resposta) => {
          this.loading = false;
          resposta.data.dataLimite = new Date(resposta.data.dataLimite);
          this.viewModel = resposta.data;
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Novo() {
      this.loading = true;
      this.$http({
        url: "configuracao-email/novo",
        data: this.viewModel,
        method: "POST"
      })
        .then((resp) => {
          this.loading = false;
          this.Testar(resp.data.id);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Editar() {
      this.loading = true;
      this.$http({
        url: "configuracao-email/editar",
        data: this.viewModel,
        method: "PUT"
      })
        .then((resp) => {
          this.loading = false;
          this.Testar(resp.data.id);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Testar(id) {
      this.loading = true;
      this.$http({
        url: "configuracao-email/testar/" + id,
        method: "GET"
      })
        .then(() => {
          this.loading = false;
          this.$notify({
            data: ["Configuração salva e testada com sucesso."],
            type: "success",
            duration: 10000
          });
          this.$router.push("/configuracao-email");
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    }
  }
};
</script>
